import React from 'react';
import { Messages, Control, Code, Name, Title, Actions, Form, Files, Toast, Button, API, Utility, useListContext, useCallback, useEffect, useState, Hooks } from 'helpers/ListImports';
import { Invoice } from 'models/InvoiceModel';


const InvoiceList: React.FC = () => {
  const width = { sno: 12, client:34, amount: 12, segment:14,  date: 14, createdby: 14 }
  const [formId, formName] = [Code.Form.Id.INVOICE, Code.Form.Name.INVOICE];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [invoiceData, setInvoiceData] = useState<Invoice[]>([]); 
  const [selectedInvoice, setselectedInvoice] = useState<Invoice | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const triggers = [pno, pageRows, search, activeId, userId];
  const Privilege = Hooks.Privilege.List(formId);
  const PriClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  const PriSpecial = Hooks.Privilege.Special();
  const locationId = Utility.Storage.LocationId();
  const doctorList = Utility.Convert.HashString(Utility.Storage.DoctorList());
  
  Hooks.Privilege.HasView(Privilege);

  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);

    //console.log("---------->",PriSpecial);

  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Invoice.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Invoice.Number, 
        Name.Invoice.Date, 
        Name.Client.Id, 
        Name.Client.FullName, 
        Name.Invoice.Net,
        Name.Common.SegmentName,
        Name.User.FullName,
        Name.Sale.Id
      ]),
      user_id: userId,
      location_id: locationId,
      ...(PriSpecial.includes("#10#") && { doctor_list: doctorList })
    });
    await API.Data.List<Invoice>(url, setInvoiceData, setError, setLoading); 
 }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId}  Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.User} value={userId} options={userOptions} onChange={setUserId} />
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, invoiceData, setSelectAllChecked,formName)} extra={3} />
              <Control.Grid.Items values={[
                [Title.InvoiceNo, width.sno], 
                [Title.ClientName, width.client], 
                [Title.Amount, width.amount, Code.Align.RIGHT],
                [Title.Date, width.date],
                [Title.Segment, width.segment],
                [Title.CreatedBy, width.createdby]
              ]} last={1} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(invoiceData) && (
              <Control.Grid.Row>
                {invoiceData.map((invoiceData) => { return (
                  <Control.Grid.Data<Invoice> key={invoiceData.invoice_id} itemKey={invoiceData.invoice_key} data={invoiceData} setMenuPosition={setMenuPosition} setSelectedData={setselectedInvoice} setShowMenu={setShowMenu}>
                    <Control.Grid.Check keyId={invoiceData.invoice_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                    <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, invoiceData.invoice_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Print path={Utility.Join.Print(Privilege, formName, invoiceData.invoice_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Sale path={Utility.Join.Edit(Privilege, Code.Form.Name.SALE, invoiceData.sale_id)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Text value={invoiceData.invoice_number} width={width.sno} />
                    <Control.Grid.Link value={Utility.Get.FullName(invoiceData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(PriClient, Code.Form.Name.CLIENT, invoiceData.client_id)} width={width.client} iframeRef={iframeRef} />
                    <Control.Grid.Items values={[
                      [Utility.Format.Amount(invoiceData.invoice_net_amount), width.amount, Code.Align.RIGHT],
                      [Utility.Format.DateOnly(invoiceData.invoice_date), width.date], 
                      [invoiceData.segment_name, width.segment], 
                      [Utility.Get.FullName(invoiceData,Code.Form.Name.USER), width.createdby], 
                    ]} /> 
                    <Control.Grid.Actions>
                      <Control.Action.All formName={formName} activeId={activeId} keyId={invoiceData.invoice_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                    </Control.Grid.Actions>
                  </Control.Grid.Data>)})}
              </Control.Grid.Row>
            )}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={invoiceData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, `${formName}/${selectedInvoice?.invoice_key}`)} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedInvoice?.invoice_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default InvoiceList;